import { LiaTransparentElement } from '@liasoft/lit-ui';
import { html, nothing } from 'lit';
import { navigate } from '../../router.js';
import { exchangeLogin, setDeveloper } from '../api/developer.js';
import { safeNext } from '../../shared/paths.js';

/**
 * Where a browser sign-in lands after the provider's redirect.
 *
 * The callback hands the browser a single-use code rather than the session, so nothing that signs
 * somebody in ever sits in a URL, a referrer or a proxy log. This page spends the code - once, within
 * a minute of it being minted - and goes where the sign-in said.
 */
export class UserLoginExchange extends LiaTransparentElement
{
   static properties = { refusal: { state: true } };

   constructor()
   {
      super();
      this.refusal = '';
   }

   connectedCallback()
   {
      super.connectedCallback();
      void this.redeem();
   }

   async redeem()
   {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (!token)
      {
         this.refusal = 'This link carries no sign-in.';
         return;
      }

      try
      {
         const signedIn = await exchangeLogin(token);

         setDeveloper({
            token: signedIn.session,
            principalId: signedIn.principalId,
            email: signedIn.email ?? '',
            expiresAt: signedIn.expiresAt
         });

         navigate(safeNext(params.get('next')) ?? '/', { replace: true });
      }
      catch (error)
      {
         this.refusal = error.message;
      }
   }

   render()
   {
      return html`
         <lia-auth-layout brand="covdbg" brand-icon="fa-solid fa-bug" heading="Signing in" .showThemeToggle=${false}>
            ${this.refusal
               ? html`
                  <lia-alert
                     variant="danger"
                     heading="That sign-in cannot be finished"
                     message=${`${this.refusal} A sign-in is finished once, within a minute of the provider answering.`}
                  ></lia-alert>
                  <a class="btn btn-outline-secondary w-100 mt-3" href="/login">Start again</a>`
               : html`
                  <p class="text-body-secondary small text-center mb-0">
                     <lia-spinner size="sm" class="me-2"></lia-spinner>One moment
                  </p>`}
         </lia-auth-layout>`;
   }
}

customElements.define('user-login-exchange', UserLoginExchange);
